import { useState, Fragment } from 'react';
import {
  DataGrid,
  Column,
  Editing,
  Texts,
  Lookup,
  HeaderFilter,
  Search,
} from 'devextreme-react/data-grid';
import notify from 'devextreme/ui/notify';
import {
  CreateAuthorizedDataSource, CreateAuthorizedStore, getAuthorizationTokenAsync
} from '~/helpers/data';
import { appConst } from '~/app-const';
import { ExternalMailSystem } from '~/components/external-mail-system/external-mail-system';
import { EmailClient } from '~/components/email-client/email-client';

export function DivisionDistributionList (props) {
  const [viewEmailClient, setViewEmailClient] = useState(false);
  const [emailFormData, setEmailFormData] = useState();

  const emailAddressTypesData = CreateAuthorizedDataSource(
    { loadUrl: `${window.env.apiEndpoint}/api/v1/Members/EmailAddressTypesLookup` },
    null,
    'Value', false,
  );

  const divisionDistributionListData = CreateAuthorizedDataSource(
    {
      loadUrl: `${window.env.apiEndpoint}/api/v1/Divisions/GetDivisionDistributionLists`,
      insertUrl: `${window.env.apiEndpoint}/api/v1/Divisions/PostDivisionDistributionList`,
      updateUrl: `${window.env.apiEndpoint}/api/v1/Divisions/PutDivisionDistributionList`,
      deleteUrl: `${window.env.apiEndpoint}/api/v1/Divisions/DeleteDivisionDistributionList`,
    },
    {
      load: { divisionId: props.divisionId },
      insert: { divisionId: props.divisionId },
      update: { divisionId: props.divisionId },
    },
    'Id', false,
  );

  return (
    <Fragment>
      <DataGrid
        dataSource={divisionDistributionListData}
        key="Id"
        {...appConst.defaultGridOptions}
        onRowUpdating={
          (e) => {
            e.newData = { ...e.oldData, ...e.newData };
          }
        }
        height='100%'
      >
        <HeaderFilter
          visible
        >
          <Search enabled={true}/>
        </HeaderFilter>
        <Editing
          mode="row"
          allowAdding
          allowDeleting
          allowUpdating
        >
          <Texts
            confirmDeleteMessage={"Are you sure to delete this division distribution list."} />
        </Editing>
        <Column
          dataField="EmailAddressTypeId"
          dataType="number"
          caption="Email Address Type"
        >
          <Lookup
            dataSource={emailAddressTypesData.store()}
            valueExpr="Value"
            displayExpr="Text"
          />
        </Column>
        <Column
          dataField="Name"
          dataType="text"
          caption="Name"
          allowEditing={false} />
        <Column
          dataField="StatusMessage"
          cellRender={
            (data) => {
              const row = data.data;
              return <ExternalMailSystem statusMessage={row.StatusMessage} hasError={row.HasError} entityId={row.Id} entityType="DivisionDistributionList" />
            }
          }
        />
        <Column
          type="buttons"
          width={110}
          buttons={[
            {
              name: "delete",
              hint: "Delete division Distribution List",
              icon: 'trash',
            },
            {
            name: "edit",
            hint:"Edit division Distribution List",
            icon: 'edit',
            },
            {
              name: "email",
              hint: "Send Email to Distribution List",
              icon: 'email',
              visible: (e) => {
                return !e.row.isEditing;
              },
              onClick: async (e) => {
                const token = await getAuthorizationTokenAsync();

                const defaultFromEmailDS = CreateAuthorizedStore({ loadUrl: `${window.env.apiEndpoint}/api/v1/DistributionList/GetDefaultFromEmail` }, null, 'Value');
                defaultFromEmailDS.load().then(
                  (data) => {
                    setViewEmailClient(true);
                    setEmailFormData({ email: token.account.username, name: data[0].fromName, to: e.row.data.Name });
                  },
                  (error) => {
                    notify({ message: error.message, shading: true }, 'error');
                  }
                );
              },
            },
          ]}
        />
      </DataGrid>
      <EmailClient visible={viewEmailClient} formData={emailFormData} setViewEmailClient={setViewEmailClient} />
    </Fragment>
  );
}